<template>
  <div
    class="bg-gray-800 text-white py-6 transition-width duration-200"
    :class="[expanded ? 'w-72 p-6' : 'w-16 p-4']"
  >
    <div class="grid grid-cols-1-auto">
      <div class="uppercase font-medium tracking-widest" v-if="expanded">Control</div>
      <div class="mb-4" :class="[expanded ? 'text-right' : 'text-center']">
        <wd-button transparent @input="toggleExpand">
          <icon :name="expanded ? 'Minimize' : 'Expand'" size="1.2em" />
        </wd-button>
      </div>
    </div>
    <div :class="{'text-center w-full': expanded}">
      <sidebar-element
        link="/dashboard"
        icon="Dashboard"
        :expanded="expanded"
      >{{$t('dashboard.dashboard')}}</sidebar-element>
      <sidebar-element
        link="/users"
        icon="Person"
        :expanded="expanded"
        v-if="roleCheck(['Admin', 'Manager'])"
      >{{$t('users.users')}}</sidebar-element>
      <sidebar-element
        link="/activity-categories"
        icon="ActivityCategory"
        :expanded="expanded"
        v-if="roleCheck(['Admin', 'Manager'])"
      >{{$t('activities.activity_categories')}}</sidebar-element>
      <sidebar-element
        link="/activities"
        icon="Activity"
        :expanded="expanded"
        v-if="roleCheck(['Admin', 'Manager'])"
      >{{$t('activities.activities')}}</sidebar-element>
      <sidebar-element
        link="/news-categories"
        icon="NewsCategory"
        :expanded="expanded"
        v-if="roleCheck(['Admin', 'Manager', 'Editor'])"
      >{{$t('news.news_categories')}}</sidebar-element>
      <sidebar-element
        link="/news"
        icon="News"
        :expanded="expanded"
        v-if="roleCheck(['Admin', 'Manager', 'Editor'])"
      >{{$t('news.news')}}</sidebar-element>
      <sidebar-element
        link="/surveys"
        icon="Survey"
        :expanded="expanded"
        v-if="roleCheck(['Admin', 'Manager', 'Editor'])"
      >{{$t('surveys.surveys')}}</sidebar-element>
      <sidebar-element
        link="/images-collection"
        icon="Image"
        :expanded="expanded"
        v-if="roleCheck(['Admin', 'Manager', 'Editor'])"
      >{{$t('images.images')}}</sidebar-element>
    </div>
  </div>
</template>

<script>
const SidebarElement = require("@/modules/sidebar/components/SidebarElement.vue")
  .default;

export default {
  name: "WdSidebar",
  data() {
    return {
      expanded: true
    };
  },
  props: {},
  components: {
    SidebarElement
  },
  methods: {
    toggleExpand() {
      this.expanded = !this.expanded;
    }
  },
  computed: {},
  created() {}
};
</script>